import { motion } from "framer-motion";
import styled from "styled-components/macro";

import icon_checkmark from "../../../assets/icons/icon_checkmark.svg"

export const AnimatedSection = styled.section`
  width: 100%;
`

export const ImgBlock = styled.div<{ src: string }>`
  border-radius: 12px;
  margin-bottom: 24px;
  width: 50%;
  height: 524px;
  background-image: ${({ src }) => `url(${src})`};
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
`

export const AnimatedItem = styled(motion.div)`
  display: flex;
  gap: 24px;

  &:last-child ${ImgBlock} {
     margin-bottom: 0;
  }
`

export const ContentBlock = styled.div`
  width: 50%;
  border-left: 1px solid #B4B4B4;
  padding: 26px 48px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
`

export const NumberBlock = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 14px;
`

export const Circle = styled.div`
  width: 8px;
  height: 8px;
  background-color: #55749F;
  border-radius: 50%;
  margin-right: 6px;
`

export const Number = styled.span`
  font-size: 18px;
`

export const Title = styled.h3`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 35px;
  margin-bottom: 26px;
  font-weight: 600;
  
  span {
   color: #55749F;
  }
`

export const Description = styled.p`
  font-size: 18px;
  margin-bottom: 45px;
`

export const TitleStrong = styled.span`
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 26px;
`

export const List = styled.ul``

export const ListItem = styled.li`
  display: flex;
  align-items: center;
  gap: 14px;
  min-height: 25px;
  margin-bottom: 8px;
`

export const Icon = styled.span`
  display: inline-block;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 16px;
  height: 11px;
  background-image: url(${icon_checkmark});
`

export const Text = styled.span`
  font-size: 18px;
`
